import { EChargeMethodType } from "../../Enum/EChargeMethodType"

export class SubscriptionPurchaseResult {
  chargeId: number

  method: EChargeMethodType

  pixQrCode?: string

  pixQrCodeBase64?: string

  pixExpiresAtUtc?: Date

  initPointUrl?: string

  expiresAtUtc?: Date

  grossAmount: number

  discountAmount: number

  finalAmount: number

  constructor(data: Partial<SubscriptionPurchaseResult> = {}) {
    this.chargeId = data.chargeId ?? 0

    this.method = data.method ?? EChargeMethodType.Pix

    this.pixQrCode = data.pixQrCode

    this.pixQrCodeBase64 = data.pixQrCodeBase64

    this.pixExpiresAtUtc = data.pixExpiresAtUtc ? new Date(data.pixExpiresAtUtc) : undefined

    this.initPointUrl = data.initPointUrl

    this.expiresAtUtc = data.expiresAtUtc ? new Date(data.expiresAtUtc) : undefined

    this.grossAmount = data.grossAmount ?? 0

    this.discountAmount = data.discountAmount ?? 0

    this.finalAmount = data.finalAmount ?? 0
  }
}
